import angularChartist from 'angular-chartist.js';
import 'angular-file-saver/dist/angular-file-saver.bundle.js';
import 'angular-translate';
import { environment } from '../../../environments/environment';
angular
    .module('PlatformExam', [
    'ngMaterial',
    'ngRoute',
    'ngSanitize',
    'ngMessages',
    'chart.js',
    angularChartist,
    'ngFileSaver',
    'hc.marked',
    'ngAnimate',
    'ngPassword',
    'updateMeta',
    '720kb.socialshare',
    'angular-bind-html-compile',
    'md-steppers',
    'angular-google-analytics',
    'pascalprecht.translate',
    'GlobalControllers',
    'ConfigPlatform',
    'BlogControllers',
    'PartnersControllers',
    'UserExamControllers',
    'UserControllers',
    'TeacherControllers',
    'ManagerControllers',
    'LessonControllers'
])
    //config for routes
    .config([
    '$routeProvider',
    function ($routeProvider) {
        $routeProvider.when('/', {
            template: '<div ng-if="(main.me.roles)" ng-include="\'/ng1/www/modules/\'+ main.me.roles[main.me.current_role] +\'/index/html/home.html\'"></div> \
          <div ng-if="!main.me.roles" ng-include="\'/ng1/www/modules/global/others/html/index.html\'"></div>'
        });
        // .otherwise('/');
    }
])
    .config([
    'AnalyticsProvider',
    function (AnalyticsProvider) {
        var _a, _b;
        if ((_a = environment === null || environment === void 0 ? void 0 : environment['analytics']) === null || _a === void 0 ? void 0 : _a.ga) {
            AnalyticsProvider.setAccount((_b = environment === null || environment === void 0 ? void 0 : environment['analytics']) === null || _b === void 0 ? void 0 : _b['ga']); //UU-XXXXXXX-X should be your tracking code
        }
    }
])
    .run(['Analytics', function (Analytics) { }])
    .config([
    'markedProvider',
    function (markedProvider) {
        markedProvider.setOptions({
            breaks: true
        });
    }
]);
//# sourceMappingURL=main.js.map